import * as yup from "yup";

export const registerSchema = yup.object().shape({
  name: yup
    .string()
    .required("Name is required")
    .min(2, "Name must be at least 2 characters")
    .max(50, "Name must not exceed 50 characters")
    .trim(),

  email: yup
    .string()
    .required("Email is required")
    .email("Invalid email address")
    .trim(),

  mobileNumber: yup
    .string()
    .test(
      "is-valid-phone",
      "Mobile number must be at least 10 digits",
      function (value) {
        if (!value || value.trim() === "") return true;

        const digitsOnly = value.replace(/\D/g, "");
        return digitsOnly.length >= 10;
      }
    )
    .nullable()
    .notRequired(),

  password: yup
    .string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters"),
  confirmPassword: yup
    .string()
    .required("Please confirm your password")
    .oneOf([yup.ref("password")], "Passwords do not match"),
});
